export default {
  name: {
    id: 'rm_metal_cadmium_name',
    defaultMessage: 'Cadmium',
  },
  smartphoneLabel: {
    id: 'rm_metal_cadmium_smartphone_label',
    defaultMessage: 'Trace (invisible to the naked eye)',
  },
  whatItDoesText: {
    id: 'rm_metal_cadmium_what_it_does',
    defaultMessage:
      'Cadmium has no significant role in modern smartphones. Some older mobile phones used Ni-Cd batteries, which have largely been replaced by lithium-ion batteries. The EU Restriction of Hazardous Substances (RoHS) Directive has restricted the use of cadmium in electronic equipment since 1 July 2006. Today, cadmium is used mainly in industrial Ni-Cd batteries, alloys, coatings, pigments and CdTe solar cells.',
  },
  extractionText1: {
    id: 'rm_metal_cadmium_extraction_p1',
    defaultMessage:
      'Cadmium is not mined as a primary metal because it does not form economically viable ore deposits. It is recovered mainly as a by-product of zinc refining, with smaller amounts from lead and copper processing. In zinc smelters, cadmium-bearing dust, sponge or residues are separated, then oxidised, leached and precipitated. Electrolysis or distillation produces refined cadmium metal, powders or compounds.',
  },
  quickFactText: {
    id: 'rm_metal_cadmium_quick_fact',
    defaultMessage:
      'Cadmium is a toxic by-product recovered mainly during zinc refining. Because of its hazardous effects, its use in consumer electronic equipment is restricted.',
  },
  envSummaryText: {
    id: 'rm_metal_cadmium_env_summary',
    defaultMessage:
      'Cadmium is toxic throughout its lifecycle. Zinc mining and smelting consume energy and water and can generate cadmium-bearing dust, residues and wastewater. Without strict controls, these pollutants can contaminate soils, water and food chains.',
  },
  envWaterText: {
    id: 'rm_metal_cadmium_env_water_text',
    defaultMessage:
      'Zinc mining and processing can release cadmium into mine drainage and wastewater. Cadmium may contaminate surface water and groundwater, creating risks for aquatic ecosystems and people.',
  },
  envSoilText: {
    id: 'rm_metal_cadmium_env_soil_text',
    defaultMessage:
      'Mining and zinc-smelting activities can release cadmium-bearing dust and residues that contaminate soils. Cadmium can then enter crops and food chains.',
  },
  envBiodiversityText: {
    id: 'rm_metal_cadmium_env_biodiversity_text',
    defaultMessage:
      'Mine drainage and smelting pollution can release cadmium into ecosystems and harm aquatic organisms.',
  },
  envClimateText: {
    id: 'rm_metal_cadmium_env_climate_text',
    defaultMessage:
      'The energy and emissions associated with cadmium are linked mainly to the zinc mining, smelting and refining processes through which it is recovered.',
  },
  humanSummaryText: {
    id: 'rm_metal_cadmium_human_summary',
    defaultMessage:
      'Cadmium exposure can occur through inhalation, contaminated food and water, and smoking. Long-term exposure is associated with kidney dysfunction, bone demineralisation, cardiovascular disease and cancer. Occupational risks are particularly high in mining, smelting, manufacturing and recycling without adequate controls. The EU RoHS Directive has restricted cadmium in electrical and electronic equipment since 1 July 2006, with exemptions, because of its risks to human health and the environment.',
  },
  humanHealthText: {
    id: 'rm_metal_cadmium_human_health_text',
    defaultMessage:
      'Cadmium is highly toxic. Acute inhalation can cause severe lung damage, while long-term exposure can damage the kidneys and bones and increase the risk of cardiovascular disease and cancer. Cadmium and cadmium compounds are classified as Group 1 carcinogens. Japan’s Itai-itai disease is a landmark example of chronic cadmium poisoning: cadmium released from the Kamioka Mine contaminated the Jinzu River basin and the water used to irrigate rice fields in Toyama Prefecture. Patients suffered severe bone pain, bone softening, fractures and renal damage.',
  },
  humanLegalText: {
    id: 'rm_metal_cadmium_human_legal_text',
    defaultMessage:
      'Cadmium is subject to strict controls. The EU REACH and RoHS frameworks restrict its use in products, while the EU Battery Regulation bans cadmium in portable batteries from 2025. Occupational exposure limits and rules on waste, food, water and transboundary movement also apply.',
  },
  geoSummaryText: {
    id: 'rm_metal_cadmium_geo_summary',
    defaultMessage:
      'Cadmium supply is concentrated but is not controlled by cadmium mining. Because cadmium is mainly a by-product of zinc refining, its availability depends on zinc production and on whether smelters recover cadmium or store it in residues. China leads global output, while the EU relies on imports and secondary supply.',
  },
  geoDugText: {
    id: 'rm_metal_cadmium_geo_dug_text',
    defaultMessage:
      'There is no significant cadmium mining. Cadmium is recovered mainly from zinc ores, especially sphalerite, with smaller amounts associated with lead and copper sulphide deposits.',
  },
  geoProcessedText: {
    id: 'rm_metal_cadmium_geo_processed_text',
    defaultMessage:
      'More than half of global cadmium refinery production is concentrated in China and South Korea. In 2024, China accounted for approximately 39% of global refinery production and South Korea for approximately 19%. These figures refer to refined cadmium, not mine production.',
  },
  geoLeverageText: {
    id: 'rm_metal_cadmium_geo_leverage_text',
    defaultMessage:
      'Cadmium supply is indirectly exposed to decisions in the zinc sector and to regulations on cadmium-bearing residues. China’s leading position gives it influence, while restrictions on the transboundary movement of cadmium sponge could disrupt supply flows. However, existing stocks of cadmium sponge and rapidly installable refining capacity limit the risk of a sustained shortage.',
  },
  supplySummaryText: {
    id: 'rm_metal_cadmium_supply_summary',
    defaultMessage:
      'Demand for cadmium from clean-energy technologies is projected to decrease by approximately 10%, from 1.0 kt in 2025 to 0.9 kt in 2050. However, cadmium supply remains linked to zinc refining and environmental regulations.',
  },
  supplyReservesText: {
    id: 'rm_metal_cadmium_supply_reserves_text',
    defaultMessage:
      'No direct cadmium reserve estimate exists because cadmium is not mined as a primary commodity. Its potential supply is linked to zinc resources and reserves, but these figures cannot be directly converted into cadmium reserves.',
  },
  supplyDemandText: {
    id: 'rm_metal_cadmium_supply_demand_text',
    defaultMessage:
      'The IEA projects that clean-energy demand for cadmium will decline by approximately 10%, from 1.0 kt in 2025 to 0.9 kt in 2050. Almost all projected demand comes from solar PV, with a small contribution from other low-emissions power generation.',
  },
  recyclingSummaryText: {
    id: 'rm_metal_cadmium_recycling_summary',
    defaultMessage:
      'Cadmium recycling is relatively efficient but uneven. Available estimates put the global recycling rate at approximately 30%, with recycled materials providing around 23% of total supply. Ni-Cd batteries can be recycled at rates exceeding 75% by weight, while more than 90% of cadmium can be recovered from certain thin-film solar panels, known as CdTe panels. These figures do not concern cadmium recycling from smartphones, which generally contain negligible amounts of cadmium.',
  },
  recyclingInputText: {
    id: 'rm_metal_cadmium_recycling_input_text',
    defaultMessage:
      'Recycled materials account for approximately 23% of global cadmium supply. This is an overall figure for cadmium across all sectors, not a smartphone-specific recycling rate. Smartphones generally contain negligible amounts of cadmium.',
  },
  recyclingOutlookText: {
    id: 'rm_metal_cadmium_recycling_outlook_text',
    defaultMessage:
      'Cadmium can be recovered from collected Ni-Cd batteries and certain thin-film solar panels, but the total amounts available for recycling are limited. As Ni-Cd batteries are phased out, less cadmium may be available for recycling. These figures do not describe recycling from smartphones.',
  },
  footnote1Text1: {
    id: 'rm_metal_cadmium_footnote_1_p1',
    defaultMessage:
      'As cadmium is not covered by the ADEME 2024 study, its environmental, social, geopolitical and supply-risk scores were calculated by Back Market’s Sustainability team using ADEME’s methodology, public sources and AI assistance. These scores carry greater uncertainty. See the Sources tab for the full methodology and references.',
  },
  footnote2Text1: {
    id: 'rm_metal_cadmium_footnote_2_p1',
    defaultMessage:
      'For co-product metals, the data refer to production at the refining stage. For cadmium, “Top Mining Countries” should be understood as “Top Refining Countries”, because cadmium is mainly recovered as a by-product of zinc smelting.',
  },
} as const
